export function loadScript(url: string) {
  return new Promise((resolve, reject) => {
    const scriptEle = document.createElement('script')
    scriptEle.type = 'text/javascript'
    scriptEle.async = true
    scriptEle.src = url
    scriptEle.onload = () => {
      resolve(url)
    }
    scriptEle.onerror = () => {
      reject(new Error('Script load error'))
    }
    document.head.appendChild(scriptEle)
  })
}
